import React, { useState } from "react";
import useData from "../../hooks/useData";
import { Flex, Modal, Popover, Table, Tag, Button } from "antd";
import { Link } from "react-router-dom";
import NumberFormat from "../../utils/NumberFormat";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import SelectUser from "../../Components/SelectUser/SelectUser";
import extractName from "../../utils/extractName";
import { PrinterFilled } from "@ant-design/icons";

const PurchaseRequestList = () => {
  const { data } = useData("/products/purchaseRequest", []);
  const { data: dealers } = useData("/products/dealers", []);
  const { data: users } = useData("/products/users");
  const [print, setPrint] = useState(false);

  dayjs.locale("ru");
  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
      render: (t) => dayjs(t).format("D MMMM YYYY"),
    },
    {
      title: "Позиций",
      dataIndex: "products",
      key: "products",
      render: (t) => t.length,
    },
    {
      title: "Всего",
      dataIndex: "totalAmount",
      key: "price",
      render: (t) => `${NumberFormat(t)} ₾`,
    },
    {
      title: "Автор",
      dataIndex: "author",
      key: "author",
      render: (text) => (
        <SelectUser
          selected={[text]}
          disabled={true}
          options={users
            ?.filter((user) => user._id === text)
            .map((team) => ({
              label: extractName(team.name),
              value: team._id,
            }))}
          onChange={() => {}}
        />
      ),
    },
    {
      title: "Действия",
      dataIndex: "actions",
      key: "actions",
      render: (_, t) => (
        <Button
          type={"primary"}
          ghost
          icon={<PrinterFilled />}
          onClick={() => setPrint(t._id)}
        >
          Печать
        </Button>
      ),
    },
  ];

  const expandableColumns = [
    {
      title: "№",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 30,
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      width: 500,
      render: (text, record) => (
        <Flex gap={12} align={"center"}>
          {record?.file ? (
            <Popover
              zIndex={3000}
              placement={"right"}
              content={
                <>
                  <img
                    src={record.file}
                    width={200}
                    height={200}
                    style={{
                      background: "#FFF",
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                </>
              }
            >
              <img
                src={record.file}
                width={32}
                height={32}
                style={{
                  background: "#FFF",
                  maxWidth: "100%",
                  height: "auto",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: 2,
                }}
              />
            </Popover>
          ) : null}
          <Flex vertical>
            <div>{record.name}</div>
            <Tag>{record.code}</Tag>
          </Flex>
        </Flex>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Цена за единицу",
      dataIndex: "price",
      key: "price",
      render: (text) => `${NumberFormat(text)} ₾`,
      sorter: (a, b) => a.price - b.price,
    },
    {
      title: "Всего",
      dataIndex: "price",
      key: "total",
      render: (text, b) => `${NumberFormat(text * b.quantity)} ₾`,
      sorter: (a, b) => a.total - b.total,
    },
    {
      title: "Магазин",
      dataIndex: "dealer",
      key: "dealer",
      render: (text) => dealers.find((d) => d._id === text)?.name,
      sorter: (a, b) =>
        dealers
          .find((d) => d._id === a.dealer)
          ?.name.localeCompare(dealers.find((d) => d._id === b.dealer)?.name),
    },
    {
      title: "Комментарий",
      dataIndex: "comment",
      key: "comment",
      sorter: (a, b) => a.comment.localeCompare(b.comment),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Заявки на закупку</h4>
            </div>
          </div>
          <div className="page-btn">
            <Link to="/purchase/request" className="btn btn-primary">
              Заявка на закупку
            </Link>
          </div>
        </div>
        <Table
          dataSource={data}
          columns={columns}
          expandable={{
            expandedRowRender: (record) => (
              <Table
                id={record._id}
                key={record._id}
                dataSource={record.products}
                columns={expandableColumns}
                pagination={false}
              />
            ),
            rowExpandable: (record) => record.products.length > 0,
          }}
          rowKey="_id"
          pagination={false}
        />
        <Modal
          open={print}
          onCancel={() => setPrint(false)}
          footer={false}
          width={950}
        >
          <iframe
            key={`${print}-${new Date().getTime()}`}
            src={`/purchase/print/${print}`}
            height={600}
            style={{
              width: "100%",
              background:
                "#fcfcfc url(https://assets-v2.lottiefiles.com/a/d28da518-1163-11ee-9080-734980550a38/YGbwmT4GIu.gif) center center no-repeat",
              backgroundSize: "100px",
            }}
          />
        </Modal>
      </div>
    </div>
  );
};

export default PurchaseRequestList;
